import { AuthRole } from "./types/AuthRole";

/**
 * Defines user roles, which have each authority
 */
export const SuperUserRoles: AuthRole[] = [AuthRole.SUPPORT];
